import React, {useState, useEffect, useRef} from 'react'
import { faPlus, faTimesCircle, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import Editor from 'react-simple-wysiwyg';
import { genNextId } from '../../utils/globalUtils';
import { experienceLevelUtil, jobTypesUtil, workModeUtil } from '../../utils/jobUtils';
import DateControl from '../../global/components/DateControl';

const Works = ({params}) => {

    const [showForm, setShowForm] = useState(false);
    const [formMode, setFormMode] = useState("insert");
    const [formId, setFormId] = useState(0);
    const [employer, setEmployer] = useState("");
    const [jobTitle, setJobTitle] = useState("");
    const [jobLevel, setJobLevel] = useState("");
    const [jobType, setJobType] = useState("");
    const [jobMode, setJobMode] = useState("");
    const [location, setLocation] = useState("");
    const [start, setStart] = useState({day:"", month:"", year:""});
    const [end, setEnd] = useState({day:"", month:"", year:""});
    const [ongoing, setOngoing] = useState(false);
    const [description, setDescription] = useState("");
    const [frmError, setFrmError] = useState("");

    const data = [...params.works];

    const handleOngoing = (event) => {
        setOngoing(event.target.checked);
    };

    const handleDescription = (e)=>{
        setDescription(e.target.value)
    }

    function newWork(){
        clearForm();
        setFormMode("insert");
        setShowForm(true);
    }

    function editWork(id){
        setFormMode("edit");
        setShowForm(true);

        const obj = data.find(x=>parseInt(x.Id) == parseInt(id));
        setFormId(obj.Id);
        setEmployer(obj.Employer);
        setJobTitle(obj.JobTitle);
        setJobLevel(obj.JobLevel);
        setJobType(obj.JobType);
        setJobMode(obj.JobMode);
        setLocation(obj.Location);
        setStart(obj.Start);
        setEnd(obj.End);
        setOngoing(obj.Ongoing);
        setDescription(obj.Description);
    }

    function closeForm(){
        setShowForm(false);
    }

    function addWork(){

        setFrmError("");

        if(employer == ""){
            setFrmError("Please enter employer");
            return;
        }

        if(jobTitle == ""){
            setFrmError("Please enter job title");
            return;
        }

        if(jobLevel == ""){
            setFrmError("Please select job level");
            return;
        }

        if(jobType == ""){
            setFrmError("Please select job type");
            return;
        }

        if(jobMode == ""){
            setFrmError("Please select job mode");
            return;
        }

        if(location == ""){
            setFrmError("Please enter job location");
            return;
        }
        
        if(start.month == "" || start.year == ""){
            setFrmError("Please enter start date");
            return;
        }


        if(formMode == "insert"){
            const id = genNextId(data);
            const obj = {
                Id: id,
                Employer: employer,
                JobTitle: jobTitle,
                JobLevel: jobLevel,
                JobType: jobType,
                JobMode: jobMode,
                Location: location,
                Start: start,
                End: end,
                Ongoing: ongoing,
                Description: description
            }
            data.push(obj);
        }
        else if(formMode == "edit"){
            const index = data.findIndex(x=>parseInt(x.Id) == parseInt(formId));
            data[index] = {
                Id: parseInt(formId),
                Employer: employer,
                JobTitle: jobTitle,
                JobLevel: jobLevel,
                JobType: jobType,
                JobMode: jobMode,
                Location: location,
                Start: start,
                End: end,
                Ongoing: ongoing,
                Description: description
            };
        }

        params.setWorks(data);
        setShowForm(false);
    }

    function deleteWork(id){
        const filteredData = data.filter(x=>parseInt(x.Id) != parseInt(id));
        params.setWorks(filteredData);
    }

    function clearForm(){
        setFormId(0);
        setEmployer("");
        setJobTitle("");
        setJobLevel("");
        setJobType("");
        setJobMode("");
        setLocation("");
        setStart("");
        setEnd("");
        setOngoing(false);
        setDescription("");
        setFrmError("");
    }
    
    const styles = {
        form:{
            container: {
                background: "#fff",
                paddingTop: 20,
                paddingBottom: 20,
            },
            body: {
                
            },
            showFormBtn:{
                marginBottom: 20,
                textDecoration: 'none',
            },
            label:{
                color: '#888'
            },
            input:{
                marginRight: 10,
                outline: 'none',
                boxShadow: 'none',
                transition: 'none',
                borderRadius: 30
            },
            btns:{
                display: 'flex'
            },
            addBtn:{
                width: 80,
                marginRight: 10,
                borderRadius: 30,
                fontSize: 14
            },
            closeBtn:{
                background: '#efefef',
                color: '#666',
                marginRight: 10,
                borderRadius: 30,
                fontSize: 14
            },
            frmError:{
                color: '#990000',
                fontSize: 16
            },
        },
        list:{
            body:{
                background: "#fff",
                paddingTop: 20,
                paddingBottom: 20,
            },
            item:{
                background: '#efefef',
                marginBottom: 10,
                padding: '10px 20px',
                position: 'relative',
                borderBottom: '1px solid #ccc'
            },
        },
        actions: {
            container: {
                position: 'absolute',
                top: 10,
                right: 20
            },
            btn:{
                background: 'none',
                color: '#888',
                border: 'none',
                fontSize: 15,
                outline: 'none',
                boxShadow: 'none',
                transition: 'none',
            },
            option:{
                fontSize: 14,
            },
            optionRed:{
                color: '#ff6d6d',
                fontSize: 14,
            },
        },   
    }

    const formDisplay = (
        <div style={styles.form.container}>
            <div style={styles.form.body}>

                <div className='row'>

                    <div className='col-6 col-md-6 form-group'>
                        <label style={styles.form.label}>Employer</label>
                        <input type='text' value={employer} onChange={e => setEmployer(e.target.value)} style={styles.titleInput} className="form-control form-control-sm" placeholder='Enter employer' />                
                    </div>

                    <div className='col-6 col-md-6 form-group'>
                        <label style={styles.form.label}>Job Title</label>
                        <input type='text' value={jobTitle} onChange={e => setJobTitle(e.target.value)} style={styles.titleInput} className="form-control form-control-sm" placeholder='Enter job title' />                
                    </div>

                    <div className='col-6 col-md-6 form-group'>
                        <label style={styles.form.label}>Job Level</label>
                        <select value={jobLevel} onChange={e => setJobLevel(e.target.value)} style={styles.input} className="form-control form-control-sm">
                            <option key={-1} value=''>- Select -</option>
                            {experienceLevelUtil.map((itm, i) => (
                                <option key={i} value={itm.Code}>{itm.Name}</option>
                            ))}
                        </select>
                    </div>

                    <div className='col-6 col-md-6 form-group'>
                        <label style={styles.form.label}>Job Type</label>
                        <select value={jobType} onChange={e => setJobType(e.target.value)} style={styles.input} className="form-control form-control-sm">
                            <option key={-1} value=''>- Select -</option>
                            {jobTypesUtil.map((itm, i) => (
                                <option key={i} value={itm.Code}>{itm.Name}</option>
                            ))}
                        </select>
                    </div>

                    <div className='col-6 col-md-6 form-group'>
                        <label style={styles.form.label}>Job Mode</label>
                        <select value={jobMode} onChange={e => setJobMode(e.target.value)} style={styles.input} className="form-control form-control-sm">
                            <option key={-1} value=''>- Select -</option>
                            {workModeUtil.map((itm, i) => (
                                <option key={i} value={itm.Code}>{itm.Name}</option>
                            ))}
                        </select>
                    </div>

                    <div className='col-6 col-md-6 form-group'>
                        <label style={styles.form.label}>Job Location</label>
                        <input type='text' value={location} onChange={e => setLocation(e.target.value)} style={styles.titleInput} className="form-control form-control-sm" placeholder='State, Country' />                
                    </div>

                    <div className='col-6 col-md-6 form-group'>
                        <label style={styles.form.label}>Start Date</label>
                        <DateControl date = {start} setDate = {setStart} show = {{day:false, month:true, year:true}} />               
                    </div>

                    <div className='col-6 col-md-6 form-group'>
                        <label style={styles.form.label}>End Date</label>
                        <DateControl date = {end} setDate = {setEnd} show = {{day:false, month:true, year:true}} />              
                    </div>

                    <div className='col-12 col-md-12 form-group'>
                        <label style={styles.form.label}>
                            <input type="checkbox" checked={ongoing} onChange={handleOngoing} /> I currently work here
                        </label>             
                    </div>

                    <div className='col-12 col-md-12 form-group'>
                        <label style={styles.form.label}>Job Responsibilities</label>
                        <Editor 
                            containerProps={{ style: { minHeight: 300 } }}
                            value={description}
                            onChange={handleDescription}
                        />              
                    </div>
                    

                </div>

                {(frmError != "") && 
                <div style={styles.form.frmError} className='form-group'>{frmError}</div>
                }

                <div style={styles.form.btns}>
                    <Link onClick={()=>addWork()} style={styles.form.addBtn} className='btn btn-info'>Add</Link>
                    <Link onClick={()=>closeForm()} style = {styles.form.closeBtn} className='btn'>Cancel</Link>
                </div>


            </div>
        </div>
    )

    const listDisplay = (
        <>
        {(data.length > 0) &&
            <div style={styles.list}>
                <div style={styles.body}>
                    {data.map((itm, index)=>(
                        <div style={styles.list.item}>
                            <div>{itm.Employer}</div>
                            <div style={styles.actions.container}>{actions(itm.Id)}</div>
                        </div>
                    ))}
                </div>
            </div>
        }
        <div style={styles.listFooter}>
            <Link onClick={()=>newWork()} style = {styles.form.showFormBtn}>
                <FontAwesomeIcon icon={faPlus} />&nbsp; Add Work Experince
            </Link>
        </div>
        </>
    )

    function actions(id){
        return(
            <div class="dropdown">
                <button type="button" data-toggle="dropdown" style={styles.actions.btn}>
                    <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                    <Link onClick={()=>{editWork(id)}} class="dropdown-item" style={styles.actions.option}>Edit</Link>
                    <div className="dropdown-divider"></div>
                    <Link onClick={()=>{deleteWork(id)}} class="dropdown-item" style={styles.actions.optionRed}>Delete</Link>
                </div>
            </div>
        )
    }

    return (
        <div>
            {showForm? formDisplay: listDisplay}
        </div>
    )
}

export default Works